module.exports = __webpack_public_path__ + "static/media/chexianyewucaozuoliucheng.af02750b.png";